import Axios from 'axios'
import { validateEmail, validateSite } from '..'

export const login = () => {
  const SITE_LOGIN_LOCAL_STORAGE_KEY = 'site_login_url'
  const noSiteError = document.getElementById('no-site-error')

  /**
   * Redirects to site login URL saved in browser, if it exists
   */
  const redirectToSavedSiteLoginURL = () => {
    const siteLoginURL = localStorage.getItem(SITE_LOGIN_LOCAL_STORAGE_KEY)

    // Check if site_login_url exists
    if (siteLoginURL) {
      const url = new URL(siteLoginURL)
      const urlComponents = url.hostname.split('.')
      const domain = urlComponents[1]
      const isValidDomain = domain && domain === 'howtoo'

      if (isValidDomain) {
        // Redirect to site login URL after validation
        noSiteError.style.display = 'none'
        window.location.assign(siteLoginURL)
      } else {
        // Show error
        noSiteError.style.display = 'flex'
      }
    }
  }

  // TODO: Enable auto redirection later
  // redirectToSavedSiteLoginURL()

  const redirectToSiteURL = async () => {
    const path = window.location
    const url = new URL(path)
    const urlComponents = url.hostname.split('.')
    const topLevelDomain = urlComponents[2]

    const siteURL = document.getElementById('site-login-url').value
    if (validateSite(siteURL)) {
      // Check if site exists
      const form = new FormData()
      form.append('site', siteURL)
      const siteValidationResult = await Axios.post('/validate-site', form, {
        'Content-Type': 'multipart/form-data',
      })

      /**
       * /validate-site returns success if site does not exist, as it is used for signup purposes
       * So we will only proceed when success=false
       */
      if (siteValidationResult.data.success) {
        // Show error
        noSiteError.style.display = 'flex'
      } else {
        // Create redirectURL and save it in the browser before redirecting to it
        noSiteError.style.display = 'none'

        const redirectURL = `https://${siteURL}.howtoo.${topLevelDomain}/login.html`
        localStorage.setItem(SITE_LOGIN_LOCAL_STORAGE_KEY, redirectURL)
        window.location.assign(redirectURL)
      }
    } else {
      // Show error
      noSiteError.style.display = 'flex'
    }
  }

  const sendReminderEmail = async () => {
    const emailErrors = {
      invalidEmailError: 'Please enter a valid email address.',
      genericError: 'Oops, there seems to be a problem. Please try again.',
    }

    const reminderErrorElement = document.getElementById('reminder-error')
    const email = document.getElementById('site-login-reminder-email').value

    if (validateEmail(email)) {
      const form = new FormData()
      form.append('email', email)
      const emailValidationResult = await Axios.post(
        '/send-site-login-reminder',
        form,
        {
          'Content-Type': 'multipart/form-data',
        }
      )

      if (emailValidationResult.status === 200) {
        // Display 'Thank you' page
        reminderErrorElement.style.display = 'none'
        const reminderBlock = document.getElementsByClassName(
          'send-reminder-block'
        )[0]

        const emailInThankYouBlock = document.getElementById('email-id')
        emailInThankYouBlock.innerText = `${email} `

        const thankYouBlock =
          document.getElementsByClassName('thankyou-block')[0]
        reminderBlock.style.display = 'none'
        thankYouBlock.style.display = 'flex'
        thankYouBlock.style.opacity = '1'
      } else {
        reminderErrorElement.innerText = emailErrors.genericError
        reminderErrorElement.style.display = 'flex'
      }
    } else {
      reminderErrorElement.innerText = emailErrors.invalidEmailError
      reminderErrorElement.style.display = 'flex'
    }
  }

  if (document.getElementById('site-login-submit')) {
    document.getElementById('site-login-submit').onclick = async () => {
      redirectToSiteURL()
    }
  }

  if (document.getElementById('site-url-form')) {
    document.getElementById('site-url-form').onsubmit = async (event) => {
      event.preventDefault()
      event.stopPropagation()
      redirectToSiteURL()
    }
  }

  if (document.getElementById('remind-me-button')) {
    document.getElementById('remind-me-button').onclick = async () => {
      sendReminderEmail()
    }
  }

  if (document.getElementById('reminder-form')) {
    document.getElementById('reminder-form').onsubmit = async (event) => {
      event.preventDefault()
      event.stopPropagation()
      sendReminderEmail()
    }
  }
}
